<template>
  <v-layout column>
    <v-flex xs12>
      <v-combobox
        ref="comboRef"
        v-model="value"
        :items="items"
        item-text="NameInHebrew"
        item-disabled="itemToExclude.NameInHebrew"
        :label="label"
        solo
        :multiple="multiple"
        :menu-props="{
          contentClass: 'smart-combo scrollbar-17',
          closeOnClick: false,
          closeOnContentClick: false,
          openOnClick: false,
        }"
        class="combo-select"
        small-chips
        rounded
        outlined
        :disabled="isDisabled"
        dense
        required
        clearable
        hide-details
      >
        <template v-if="!multiple" v-slot:selection="{ item }">
          <span>{{ item.NameInHebrew || value }}</span>
        </template>

        <template v-else v-slot:selection="{ index }">
          <span v-if="index === 0" class="grey--text display-16">
            נבחרו {{ value.length }} תחומים
          </span>
        </template>
      </v-combobox>
    </v-flex>

    <v-flex xs8>
      <v-layout v-if="multiple" column>
        <v-flex class="justify-center" xs10 mr-2 px-4 pt-2>
          <p
            v-for="(item, index) in value"
            :key="index"
            outlined
            class="no-border-chip display-14 pa-0 ma-0"
          >
            <span class="pa-0 ma-0">
              {{ item.NameInHebrew || value.length }}
            </span>
          </p>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { isEmpty, filter } from 'lodash';

const MAX_AREAS = 6;

export default {
  props: {
    items: {
      type: [Array, Object],
      required: false,
      default: null,
    },

    select: {
      type: String,
      required: false,
      default: '',
    },

    selected: {
      type: [Number, Object, String],
      default: null,
    },

    label: {
      type: String,
      required: false,
      default: 'בחר',
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    counter: {
      type: [Boolean, Number, String],
      default: false,
    },

    disabled: {
      type: Boolean,
    },

    itemToExclude: {
      type: Boolean,
    },
    categoryNum: {
      type: Number,
    },
    categoryType: {
      type: String,
    },
  },
  data() {
    return {
      value: '',
      // comboRules: [(v) => !!v || 'שדה חובה'],
    };
  },

  computed: {
    usersCurrSelection() {
      if (this.selected && !this.multiple) {
        const item = this.items.find((i) => i.Code === this.selected);
        this.value = item;
      }
    },

    usersSubCatsCurrent() {
      /** Migration patch  for users with more than 6 areas  IsSelected=true*/
      let areasCount = filter(this.items, 'IsSelected').length;
      let minAreas = Math.min(areasCount, MAX_AREAS);

      if (this.multiple) {
        this.value = filter(this.items, 'IsSelected');

        if (this.value.length > minAreas) {
          this.value.length = minAreas;
        }
      }
    },

    isDisabled() {
      if (this.multiple) {
        return !this.items;
      } else {
        return this.disabled ? this.disabled : false;
      }
    },
  },

  watch: {
    value(newVal, oldVal) {
      if (newVal == undefined) {
        let packEvent = {};
        packEvent.categoryType = this.categoryType;
        packEvent.categoryNum = this.categoryNum;
        packEvent.item = this.value;
        this.$emit('unselect', packEvent);
      }
      if (!this.multiple) {
        if (!isEmpty(this.value)) {
          this.$emit('categorySelected', this.value);
        }
      } else if (this.multiple) {
        this.validateAreasLimit(newVal, oldVal, 'value');
        this.$emit('addSubCat', newVal);
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.usersCurrSelection;
      this.$nextTick(() => {
        this.usersSubCatsCurrent;
      });
    });
    this.displayUsersSelection();

    this.$bus.$on('annulateSelectedChips', (e) => {
      if (this.multiple) {
        this.annulatePrevSelects(e);
      }
    });
  },

  methods: {
    required(value) {
      if (value instanceof Array && value.length == 0) {
        return 'Required.';
      }
      return !!value || 'Required.';
    },
    validateAreasLimit(newVal = 0, oldVal, model) {
      if (newVal.length > MAX_AREAS) {
        this.$nextTick(() => (this[model] = oldVal));
      }
    },

    annulatePrevSelects(packageEvent) {
      if (this.value && packageEvent.catNum === this.categoryNum) {
        this.value = '';
      }
    },

    displayUsersSelection() {
      if (this.selected) {
        this.value = this.computedValue;
      }
    },
  },

  beforeDestroy() {
    this.$bus.$off('annulateSelectedChips');
  },
};
</script>

<style lang="scss" scoped>
.no-border-chip {
  border: solid 1px #fff;
  background: #fff;
  padding: 1px;
}

.justify-center {
  align-self: flex-start;
}

@media only screen and (min-width: 600px) {
  .dr-field {
    max-width: 280px;
  }
}
</style>
